<template>
    <div id="page-text-fields">
        <v-container grid-list-xl fluid>
            <StoreStepper class="mb-2" current="template_setting"></StoreStepper>
            <div v-if="!main_loading">
                <v-layout
                        v-for="(block,ib) in data.blocks"
                        v-bind:key="ib"
                        row wrap>
                    <v-flex sm12>
                        <v-widget
                                :title="block.block_name">

                            <div slot="widget-content" v-if="block.is_manageable === 'No'">
                                <v-container v-bind:key="ir" v-for="(record,ir) in recordByBlock(block.block_id)">

                                    <v-layout v-bind:key="i" v-for="(field,i) in fieldsByBlock(block.block_id)">

                                        <v-flex v-if="field.field_type === 'textinput' || field.field_type === 'numeric'">
                                            <v-text-field
                                                    :label="field.field_fa_name.replace('ltr','',-1)"
                                                    :name="field.field_en_name"
                                                    :type="field.field_type === 'numeric'?'number':'text'"
                                                    :data-ltr="field.field_fa_name.includes('ltr')"
                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex v-else-if="field.field_type === 'textarea'">
                                            <v-textarea
                                                    :label="field.field_fa_name.replace('ltr','',-1)"
                                                    :name="field.field_en_name"
                                                    :data-ltr="field.field_fa_name.includes('ltr')"
                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex v-else-if="field.field_type === 'file'">
                                            <file-manager
                                                    :label="field.field_fa_name"
                                                    base-path="/assets/"
                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"></file-manager>
                                        </v-flex>
                                        <v-flex v-else-if="field.field_type.includes('select')">
                                            <v-autocomplete
                                                    :items="setting[field.field_id].items"
                                                    :item-text="setting[field.field_id].text"
                                                    :item-value="setting[field.field_id].value_index"
                                                    :multiple="field.field_type === 'multiple_select'"
                                                    :rules="[rules.required]"
                                                    :label="field.field_fa_name"
                                                    :name="field.field_en_name"
                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                            ></v-autocomplete>
                                        </v-flex>

                                        <v-flex v-else-if="field.field_type === 'radio'">
                                            <v-radio-group
                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']">
                                                <v-radio
                                                        v-for="(op,i) in setting[field.field_id].items"
                                                        :key="i"
                                                        :label="op.val"
                                                        :value="op.id"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-flex>

                                        <v-flex v-else-if="field.field_type === 'checkbox'">
                                            <v-checkbox
                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                                    :value="field.default_value"
                                                    :label="field.field_fa_name"></v-checkbox>
                                        </v-flex>
                                    </v-layout>

                                </v-container>
                            </div>

                            <div slot="widget-content" v-if="block.is_manageable === 'Yes'">
                                <v-container>
                                    <v-layout class="pb-3">
                                        <v-btn
                                                color="green"
                                                icon
                                                @click="addRecord(block.block_id)"
                                        >
                                            <v-icon color="white">add</v-icon>
                                        </v-btn>
                                    </v-layout>
                                    <v-expansion-panel>
                                        <v-expansion-panel-content
                                                v-bind:key="ir"
                                                v-for="(record,ir) in recordByBlock(block.block_id)"
                                        >
                                            <template v-slot:header>
                                                <div>
                                                    {{record.name}}
                                                </div>
                                            </template>
                                            <v-card>
                                                <v-card-text>
                                                    <v-layout v-bind:key="i"
                                                              v-for="(field,i) in fieldsByBlock(block.block_id)">

                                                        <v-flex v-if="field.field_type === 'textinput' || field.field_type === 'numeric'">
                                                            <v-text-field
                                                                    :label="field.field_fa_name.replace('ltr','',-1)"
                                                                    :name="field.field_en_name"
                                                                    :type="field.field_type === 'numeric'?'number':'text'"
                                                                    :data-ltr="field.field_fa_name.includes('ltr')"
                                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                                            ></v-text-field>
                                                        </v-flex>
                                                        <v-flex v-else-if="field.field_type === 'textarea'">
                                                            <v-textarea
                                                                    :label="field.field_fa_name.replace('ltr','',-1)"
                                                                    :name="field.field_en_name"
                                                                    :data-ltr="field.field_fa_name.includes('ltr')"
                                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                                            ></v-textarea>
                                                        </v-flex>
                                                        <v-flex v-else-if="field.field_type === 'file'">
                                                            <file-manager
                                                                    :label="field.field_fa_name"
                                                                    base-path="/assets/"
                                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                                            ></file-manager>
                                                        </v-flex>
                                                        <v-flex v-else-if="field.field_type.includes('select')">
                                                            <v-autocomplete
                                                                    :items="setting[field.field_id].items"
                                                                    :item-text="setting[field.field_id].text"
                                                                    :item-value="setting[field.field_id].value_index"
                                                                    :multiple="field.field_type === 'multiple_select'"
                                                                    :rules="[rules.required]"
                                                                    :label="field.field_fa_name"
                                                                    :name="field.field_en_name"
                                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                                            ></v-autocomplete>
                                                        </v-flex>

                                                        <v-flex v-else-if="field.field_type === 'radio'">
                                                            <v-radio-group
                                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']">
                                                                <v-radio
                                                                        v-for="(op,i) in setting[field.field_id].items"
                                                                        :key="i"
                                                                        :label="op.val"
                                                                        :value="op.id"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </v-flex>

                                                        <v-flex v-else-if="field.field_type === 'checkbox'">
                                                            <v-checkbox
                                                                    v-model="data.data[indexOfData(record.record_id,field.field_id)]['val']"
                                                                    :value="field.default_value"
                                                                    :label="field.field_fa_name"></v-checkbox>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout>
                                                        <v-flex>
                                                            <v-btn
                                                                    color="red"
                                                                    icon
                                                                    @click="removeRecord(record.record_id)"
                                                            >
                                                                <v-icon color="white">remove</v-icon>
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>

                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
                <v-btn block large class="white--text" type="button" @click="handleSubmit" color="blue darken-2">
                    <v-icon>save</v-icon>
                    &nbsp;
                    ذخیره
                </v-btn>

                <v-layout class="row wrap">
                    <v-flex>
                        <v-card>
                            <v-card-title>
                                منوی اصلی
                                <small> (جابجایی با کشیدن و رها کردن) </small>
                            </v-card-title>
                            <v-card-text>
                                <v-layout wrap>
                                    <v-flex>
                                        <v-btn round class="green white--text" @click="linkDialog=true">+ افزودن</v-btn>
                                        <v-btn round class="blue-grey white--text" @click="makeDefaultAction">برگردان به
                                            پیشفرض
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap>
                                    <v-flex>
                                        <dragTreeTable
                                                :data="treeData"
                                                :onDrag="onTreeDataChange"
                                                fixed
                                                border>
                                        </dragTreeTable>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </div>
            <v-layout v-else class="row wrap">
                <v-flex md12>
                    <fake-item></fake-item>
                </v-flex>
                <v-flex md12>
                    <fake-item></fake-item>
                </v-flex>
                <v-flex md12>
                    <fake-item></fake-item>
                </v-flex>
            </v-layout>
        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>

        <v-dialog
                v-model="linkDialog"
                width="50%"
        >
            <v-card>
                <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                >
                    اطلاعات لینک
                </v-card-title>

                <v-card-text>
                    <v-flex>
                        <v-text-field
                                label="عنوان"
                                v-model="newNode.name"
                                type="text"
                        ></v-text-field>
                        <v-text-field
                                label="لینک"
                                v-model="newNode.link"
                                type="text"
                                data-ltr
                        ></v-text-field>
                        <v-btn v-if="newNode.id === 0" block color="green" style="color:white" @click="addNode">افزودن
                        </v-btn>
                        <v-btn v-else color="blue" block style="color:white" @click="addNode">ذخیره</v-btn>
                    </v-flex>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="addRec"
                width="100%"
        >
            <v-card>
                <v-card-title
                        class="headline grey lighten-2"
                        primary-title
                >
                    افزودن مورد جدید
                </v-card-title>

                <v-card-text>
                    <v-form ref="newrec" @submit.prevent="addRecordRequest">
                        <v-layout>
                            <v-flex xs10>
                                <v-text-field
                                        label="عنوان رکورد"
                                        :rules="[rules.required]"
                                        v-model="CurrentAddBlockRecordName"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs2 class="pt-2">
                                <v-btn color="green" type="submit" class="white--text">ذخیره</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card-text>
                <v-card-actions>

                </v-card-actions>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import FileManager from '@/components/FileManager';
import Loading from '@/components/Loading';
import StoreStepper from '@/components/StoreStepper';
import dragTreeTable from 'drag-tree-table';

export default {
  components: {
    StoreStepper,
    VWidget,
    Loading,
    dragTreeTable,
    FileManager
  },
  data () {
    return {
      newNode: {
        name: '',
        link: '',
        id: 0,
        lists: [],
      },
      linkDialog: false,
      treeData: {
        columns: [
          {
            type: 'selection',
            title: 'عنوان',
            field: 'name',
            flex: 4,
            align: 'center',
            formatter: (item) => {
              return '<a>' + item.name + '</a>';
            },
          },
          {
            title: 'عملیات',
            type: 'action',
            flex: 1,
            align: 'center',
            actions: [
              {
                text: 'ویرایش',
                onclick: (item) => {
                  let t = this.treeData.lists.findIndex(i => i.id === item.id);
                  if (t === -1) {
                    this.snackbar.text = 'برای ویرایش یک آیتم آنرا به سطح ریشه(اصلی) ببرید';
                    this.snackbar.color = 'red';
                    this.snackbar.snackbar = true;
                  } else {
                    this.newNode = item;
                    this.linkDialog = true;
                  }
                },
                formatter: (item) => {
                  if (this.treeData.lists.findIndex(i => i.id === item.id) === -1) {
                    return '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--small theme--dark blue-grey"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--dark white--text">edit</i></div></button>';
                  }
                  return '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--small theme--dark pink"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--dark white--text">edit</i></div></button>';
                }
              },
              {
                text: 'حذف',
                onclick: (item) => {
                  let t = this.treeData.lists.findIndex(i => i.id === item.id);
                  this.treeData.lists = this.treeData.lists.filter((i) => i.id !== item.id);
                  if (t === -1) {
                    this.snackbar.text = 'برای حذف آیتم آنرا به سطح ریشه(اصلی) ببرید';
                    this.snackbar.color = 'red';
                    this.snackbar.snackbar = true;
                  } else {
                    this.onTreeDataChange(this.treeData.lists);
                  }
                },
                formatter: (item) => {
                  if (this.treeData.lists.findIndex(i => i.id === item.id) === -1) {
                    return '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--small theme--dark blue-grey"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--dark white--text">close</i></div></button>';
                  }
                  return '<button type="button" class="v-btn v-btn--floating v-btn--icon v-btn--small theme--dark red"><div class="v-btn__content"><i aria-hidden="true" class="v-icon material-icons theme--dark white--text">close</i></div></button>';
                }
              }
            ]
          },
        ],
        lists: []
      },
      main_loading: true,
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      addRec: false,
      CurrentAddBlockID: 0,
      CurrentAddBlockRecordName: '',
      shop_name: '',
      form: {
        name: '',
        ac_id: 0,
        store_id: Number(this.$route.params.store_id),
        parent_id: 0,
      },
      stores: [],
      data: {
        store: {
          shop_id: 0,
          shop_name: '',
        },
        blocks: [],
        block_fields: [],
        block_records: [],
        data: [],
      },
      v: {},
      cats: [],
      setting: {},
      product_categories: [],
      loader: null,
      loading: false,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  computed: {},
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => {
        this[l] = false;
      }, 1000);
      this.loader = null;
    }
  },
  mounted: function () {
    this.axios.get('/reseller/stores/?shop_id=' + this.$route.params.store_id)
      .then(response => {
        this.treeData.lists = response.data.Data[0].more_setting.menu.length > 4 ? JSON.parse(response.data.Data[0].more_setting.menu) : [];
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/template_data/' + this.$route.params.store_id)
      .then(response => {
        response.data.block_fields.forEach((f) => {
          this.v[f.field_id] = f.default_value;
          // Fetch select data
          if (f.field_type.includes('select')) {
            this.setting[f.field_id] = {
              items: [],
              text: '',
              value_index: '',
            };
            f.items = f.items.replace('\r', '', -1);
            let items = f.items.split('\n');
            if (f.items.includes('***')) {
              if (items.length === 2) {
                this.axios.get('/reseller/' + items[0].split('|')[1] + '/').then(response => {
                  this.setting[f.field_id].items = response.data.Data;
                }).catch(error => {
                  this.snackbar = HttpErrorToSnackbar(error);
                });
                this.setting[f.field_id].value_index = items[1].split('|')[0];
                this.setting[f.field_id].text = items[1].split('|')[1];
              }
            } else {
              items.forEach((item) => {
                this.setting[f.field_id].items.push({
                  id: item.split('|')[0],
                  val: item.split('|')[1],
                });
              });
              this.setting[f.field_id].value_index = 'id';
              this.setting[f.field_id].text = 'val';
            }
          }

          // Radio Data
          if (f.field_type.includes('radio')) {
            this.setting[f.field_id] = {
              items: [],
            };
            if (f.items.length > 0) {
              let items = f.items.split('\n');
              items.forEach((item) => {
                this.setting[f.field_id].items.push({
                  id: item.split('|')[0],
                  val: item.split('|')[1],
                });
              });
            }
          }

        });
        this.data = response.data;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      }).finally(() => {
        this.main_loading = false;
      });
  },
  methods: {
    onTreeDataChange (list) {
      this.treeData.lists = list;
      this.axios.put('/reseller/store_menu/', {
        id: Number(this.$route.params.store_id),
        data: JSON.stringify(list)
      }).catch(err => {
        this.snackbar = HttpErrorToSnackbar(err);
      });
    },
    addNode: function () {
      if (this.newNode.id === 0) {
        this.newNode.id = Math.floor(Math.random() * 99999999);
        this.treeData.lists.push(this.newNode);
      } else {
        let t = this.treeData.lists.findIndex(i => i.id === this.newNode.id);
        this.treeData.lists[t] = this.newNode;
      }
      this.onTreeDataChange(this.treeData.lists);
      this.newNode = {
        name: '',
        link: '',
        id: 0,
        lists: [],
      };
      this.linkDialog = false;
    },
    makeDefaultAction: function () {
      this.$confirm('آیا از این کار اطمینان دارید؟').then(res => {
        if (res) {
          this.makeDefault();
        }
      });
    },
    makeDefault: function () {
      if (this.cats.length === 0) {
        this.getCats();
      }
      this.sureDef = false;
      let data = [
        {
          name: 'خانه',
          link: '/',
          id: -1,
        },
        {
          name: 'دسته‌بندی‌ها',
          link: '#',
          id: -2,
          lists: [],
        }
      ];
      let cats = this.cats.filter(c => c.parent_id === 0);
      cats.forEach(c => {
        let cc = {
          name: c.name,
          id: c.ac_id,
          order: c.sort,
          link: `/category/${c.ac_id}`
        };
        cc.lists = this.category(c.ac_id);
        data[1].lists.push(cc);
      });
      this.onTreeDataChange(data);
    },
    category: function (id) {
      let cats = this.cats.filter(c => c.parent_id === id);
      let data = [];
      cats.forEach(c => {
        let cc = {
          name: c.name,
          id: c.ac_id,
          order: c.sort,
          link: `/category/${c.ac_id}`
        };
        cc.lists = this.category(c.ac_id);
        data.push(cc);
      });
      return data;
    },
    getCats: function () {
      this.axios.get('/reseller/artwork_categories/?store_id=' + this.$route.params.store_id)
        .then(response => {
          this.cats = response.data.Data;
          this.makeDefault();
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    fieldsByBlock: function (block_id) {
      return this.data.block_fields.filter(f => f.block_id === block_id);
    },
    recordByBlock: function (block_id) {
      return this.data.block_records.filter(r => r.block_id === block_id);
    },
    indexOfData: function (record_id, field_id) {
      return this.data.data.findIndex(d => d.record_id === record_id && d.field_id === field_id);
    },
    addRecord: function (block_id) {
      this.addRec = true;
      this.CurrentAddBlockID = block_id;
    },
    addRecordRequest: function () {
      if (!this.$refs.newrec.validate()) {
        return;
      }
      this.axios.post('/reseller/block_record/', {
        store: this.data.store.shop_id,
        block_id: this.CurrentAddBlockID,
        name: this.CurrentAddBlockRecordName
      })
        .then(response => {
          this.data.block_records.push(response.data.block_record);
          response.data.data.forEach(d => {
            this.data.data.push(d);
          });
          this.addRec = false;
        }).catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });
    },
    loadCategory: function (id) {
      this.axios.get('/reseller/artwork_categories/?store_id=' + id)
        .then(response => {
          let data = [{
            ac_id: 0,
            name: '** اصلی **'
          }];
          data = data.concat(response.data.Data);
          this.product_categories = data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });

    },
    removeRecord (recordID) {
      this.DeleteEntityPromise('delete_block_record_id', recordID).then(() => {
        this.data.block_records = this.data.block_records.filter(r => r.record_id !== recordID);
      }).catch(err => {
        this.snackbar = HttpErrorToSnackbar(err);
      });
    },
    handleSubmit () {
      this.axios.put('/reseller/save_template_options/' + this.data.store.shop_id, this.data.data)
        .then(() => {
          this.snackbar.text = 'با موفقیت انجام شد.';
          this.snackbar.y = 'bottom';
          this.snackbar.color = 'success';
          this.snackbar.snackbar = true;
          this.loading = false;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });

    },
  }
};
</script>
<style>
    .control_wrapper {
        display: block;
        max-width: 350px;
        max-height: 350px;
        margin: auto;
        overflow: auto;
        border: 1px solid #dddddd;
        border-radius: 3px;
    }

    .v-expansion-panel {
        text-align: right;
        direction: rtl;
    }
</style>



// WEBPACK FOOTER //
// src/pages/template_setting/edit.vue